"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AdvisrListingConnectionSection;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _styles = require("../styles");
var _analytics = require("../../../constants/analytics");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// This renders the button for listings with
// .core.listingType value === ADVISR
// ADVISR listings are also known as "Inquire" listings
// For ADVISR listings, the same button is rendered regardless of whether
// the user is on the public or in-product site.
// This is unlike the other two types of listings.
function AdvisrListingConnectionSection(_ref) {
  var onRequestInformationClick = _ref.onRequestInformationClick,
    listingId = _ref.listingId;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    },
    onClick: function onClick() {
      _nuiLogger.default.info({
        description: "Inquire button clicked on listing ".concat(listingId),
        'cte.subcategory': 'new-inquire-button-click'
      });
      onRequestInformationClick(_analytics.elementList.button);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontStyle: 'italic'
    }
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "RequestInformation"
  }))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "RequestInformationDescription"
  })));
}
AdvisrListingConnectionSection.propTypes = {
  onRequestInformationClick: _propTypes.default.func.isRequired,
  // Callback defined in parent
  listingId: _propTypes.default.string.isRequired // Callback defined in parent
};